import { useState } from 'react';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Box, Divider, MenuItem, Select, Hidden } from '@material-ui/core';

import { flag_usa, labscoop_logo } from 'assets';
import Notification from 'components/Notification';
import Icon from 'components/Icon';

import styles from './index.module.scss';

const Footer = (props) => {
  const { straight = true } = props;
  const { currentYear } = useSelector((state) => state.data);
  const [notifyPhoneCopy, setNotifyPhoneCopy] = useState(false);

  return (
    <>
      <Notification
        error={notifyPhoneCopy}
        setError={setNotifyPhoneCopy}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        severity="success"
        autoHideDuration={5000}
        errorText="Copied to clipboard successfully"
      />

      <footer className={cx(styles.footer, straight && styles.straight)}>
        <div className={styles.bg} />
        <div className={styles.wrapper}>
          <ul className={styles.menu}>
            <li>
              <h5>Product</h5>
              <Link to="/marketplace">Marketplace</Link>
              <Link to="/shared-cart">Shared Cart</Link>
              <Link to="/science-samples">ScienceSamples</Link>
              <Link to="/curator">Curator</Link>
            </li>
            <li>
              <h5>Enterprise</h5>
              <Link to="/">Solutions</Link>
              <Link to="/">Integrations</Link>
              <Link to="/">Onboarding</Link>
            </li>
            <li>
              <h5>Company</h5>
              <Link to="/about">About</Link>
              <Link to="/blogs">Blog</Link>
              <Link to="/supplier-partners">Supplier Partners</Link>
              <Link to="/open-positions">Careers</Link>
              <Link to="/newsroom">Newsroom</Link>
              <Link to="/">Press Kit</Link>
            </li>
            <li>
              <h5>Support</h5>
              <Link to="/help-center">Help Center</Link>
              <Link to="/faqs">FAQs</Link>
              <Link to="/schedule-demo">Schedule a Demo</Link>
              <Link to="/report-bug">Report a Bug</Link>
              <Link to="/make-suggestion">Make a Suggestion</Link>
            </li>
          </ul>
          <div className={styles.actions}>
            <Box className={styles.contacts}>
              <Hidden xsDown>
                <Link to="/" className={`${styles.logo} no-decoration`}>
                  <img src={labscoop_logo} alt="logo" />
                </Link>
              </Hidden>

              <a
                href="mailto:support@labscoop.com"
                className={styles.action_button}
              >
                <Icon.Telegram />
                <span>support@labscoop.com</span>
              </a>

              <CopyToClipboard
                text="800 316 3081"
                onCopy={() => {
                  setNotifyPhoneCopy(true);
                }}
              >
                <span className={styles.action_button}>
                  <Icon.PhoneFilled />
                  <span>800 316 3081</span>
                </span>
              </CopyToClipboard>
            </Box>

            <div className={styles.socials}>
              <a
                href="https://twitter.com/labscoop"
                target="_blank"
                rel="noreferrer noopener"
              >
                <Icon.TwitterX fontsize={16} />
              </a>
              <a
                href="https://www.linkedin.com/company/labscoop/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <Icon.Linkedin fontSize={16} />
              </a>
              <a
                href="https://www.instagram.com/labscoop/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <Icon.Instagram fontSize={16} />
              </a>
              <a
                href="https://www.facebook.com/labscoop/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <Icon.Facebook fontSize={16} />
              </a>
            </div>

            <Hidden smUp>
              <Box className={styles.termsWrapper}>
                <Link to="/terms-of-use">Terms of Use</Link>
                <Link to="/terms-and-conditions-of-sale">
                  Terms & Conditions of Sale
                </Link>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </Box>
              <span className={styles.lcc}>
                © {currentYear} Labscoop LLC. All rights reserved
              </span>
            </Hidden>
          </div>
        </div>

        <Divider className={styles.divider} />

        <div className={styles.wrapper}>
          <div className={styles.copyright}>
            <Hidden smUp>
              <Box className={styles.locales}>
                <Select
                  variant={'outlined'}
                  fullWidth
                  label={false}
                  placeholder={'Language'}
                  defaultValue={'en'}
                  className={styles.select}
                  MenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: 'top',
                      horizontal: 'center',
                    },
                    transformOrigin: {
                      vertical: 'bottom',
                      horizontal: 'center',
                    },
                  }}
                >
                  <MenuItem value={'en'} className={styles.menu_item}>
                    <Box display={'flex'} alignItems={'center'}>
                      <span>EN</span>
                    </Box>
                  </MenuItem>
                </Select>

                <Select
                  variant={'outlined'}
                  fullWidth
                  label={false}
                  placeholder={'Country'}
                  defaultValue={'english'}
                  className={styles.select}
                  displayEmpty
                  MenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: 'top',
                      horizontal: 'center',
                    },
                    transformOrigin: {
                      vertical: 'bottom',
                      horizontal: 'center',
                    },
                  }}
                >
                  <MenuItem value={''} hidden className={styles.menu_item}>
                    <img src={flag_usa} alt="usa" />
                    <span>Country</span>
                  </MenuItem>
                  <MenuItem value={'english'} className={styles.menu_item}>
                    <Box display={'flex'} alignItems={'center'}>
                      <img src={flag_usa} alt="usa" />
                      <span>USA</span>
                    </Box>
                  </MenuItem>
                </Select>
              </Box>
            </Hidden>

            <Hidden xsDown>
              <span className={styles.rights}>
                © {currentYear} Labscoop LLC
              </span>
            </Hidden>
            <Hidden xsDown>
              <Link to="/terms-of-use">Terms of Use</Link>
              <Link to="/terms-and-conditions-of-sale">
                Terms & Conditions of Sale
              </Link>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </Hidden>

            <Hidden xsDown>
              <Box ml={6}>
                <Select
                  variant={'outlined'}
                  fullWidth
                  label={false}
                  placeholder={'Language'}
                  defaultValue={'en'}
                  className={styles.select}
                  MenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: 'top',
                      horizontal: 'center',
                    },
                    transformOrigin: {
                      vertical: 'bottom',
                      horizontal: 'center',
                    },
                  }}
                >
                  <MenuItem value={'en'} className={styles.menu_item}>
                    <Box display={'flex'} alignItems={'center'}>
                      <span>EN</span>
                    </Box>
                  </MenuItem>
                </Select>
              </Box>
              <Box ml={2}>
                <Select
                  variant={'outlined'}
                  fullWidth
                  label={false}
                  placeholder={'Country'}
                  defaultValue={'english'}
                  className={styles.select}
                  displayEmpty
                  MenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: 'top',
                      horizontal: 'center',
                    },
                    transformOrigin: {
                      vertical: 'bottom',
                      horizontal: 'center',
                    },
                  }}
                >
                  <MenuItem value={''} hidden className={styles.menu_item}>
                    <img src={flag_usa} alt="usa" />
                    <span>Country</span>
                  </MenuItem>
                  <MenuItem value={'english'} className={styles.menu_item}>
                    <Box display={'flex'} alignItems={'center'}>
                      <img src={flag_usa} alt="usa" />
                      <span>USA</span>
                    </Box>
                  </MenuItem>
                </Select>
              </Box>
            </Hidden>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
